// extracted by mini-css-extract-plugin
export default {"desktop":"desktop_desktop__2DCVM","headingText":"desktop_headingText__TeIcJ","mainText":"desktop_mainText__soe15"};